import { IconWarning } from '@americanexpress/dls-icons';
import { Heading, Surface } from '@americanexpress/dls-react';
import React from 'react';
import { FormattedMessage, IntlProvider } from 'react-intl';

const LoadError = (props) => {
  const languageData = props?.languageData;

  return (
    <Surface variant="foreground" data-testid="enroll-page-error">
      <div className="flex flex-column flex-align-items-center pad-3-lg-up pad-2">
        <IconWarning size="xl" isFilled={true} color="critical" />
        <Heading className="margin-2-t margin-3-t-lg-up" level={2} variant="sans-medium-bold">
          <IntlProvider locale={languageData?.locale} messages={languageData}>
            <FormattedMessage
              id="We&apos;re Sorry"
              defaultMessage="We&apos;re Sorry"
            />
          </IntlProvider>
        </Heading>
        <p className="margin-2-tb">
          <IntlProvider locale={languageData?.locale} messages={languageData}>
            <FormattedMessage
              id="We&apos;re unable to load"
              defaultMessage="We&apos;re unable to load this page at this time. Please try again later."
            />
          </IntlProvider>
        </p>
        <hr />
        <p className="margin-2-tb">
          <IntlProvider locale={languageData?.locale} messages={languageData}>
            <FormattedMessage
              id="If you need immediate assistance"
              defaultMessage="If you need immediate assistance, please call the number on the back of your Card."
            />
          </IntlProvider>
        </p>
      </div>
    </Surface>
  );
};

export default LoadError;
